import gql from 'graphql-tag';
import React from 'react';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import experiments from '@reverbdotcom/commons/src/experiments';
import { experimentInt } from '@reverbdotcom/commons/src/user_context_helpers';
import { isMarketplacePage } from '@reverbdotcom/commons/src/url_helpers';

function shouldSkipQuerySuggestions(ownProps) {
  const expGroup = experimentInt(ownProps.user, experiments.MARKETPLACE_QUERY_SUGGESTIONS);
  if (!ownProps.location?.query?.query) { return true; }
  if (!isMarketplacePage(ownProps.location)) { return true; }
  if (expGroup === 0) { return true; }
  return false;
}

function searchQueries(ownProps) {
  if (ownProps?.location?.query) {
    return [
      {
        query: ownProps.location.query?.query,
        make: ownProps.location.query?.make,
        productType: ownProps.location.query?.product_type,
        category: ownProps.location.query?.category,
      },
    ];
  }
  return [];
}

const connect = gql`query MarketplaceQuerySuggestions(
  $searchQueries: [Input_reverb_personalization_SearchQuery]
) {
  querySuggestions(input: {
    queries: $searchQueries
  }) {
    queries {
      suggestions {
        query
        productType
        make
        category
        listings {
          _id
          id
          images(input: {
            type: "Product",
            scope: "photos",
            transform: "card_square"
            count: 1
          }) {
            source
          }
        }
      }
    }
  }
}`;

export default function withQuerySuggestions<IProps>(
  Component: React.ComponentType<IProps>,
): React.ComponentType<IProps> {
  const requestConfig = {
    skip: ownProps => shouldSkipQuerySuggestions(ownProps),
    options: (ownProps) => {
      return {
        ssr: false,
        variables: {
          searchQueries: searchQueries(ownProps),
        },
      };
    },
    props({ data, ownProps }) {
      const { querySuggestions, loading } = data;
      const suggestions = querySuggestions?.queries ? querySuggestions.queries[0].suggestions : [];
      const props = {
        ...ownProps,
        querySuggestions: suggestions,
        loading,
      };
      return props;
    },
  };
  return withGraphql(connect, requestConfig)(Component) as React.ComponentType<IProps>;
}
